(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirefdb2"];
var parcelRegister = parcelRequire.register;
parcelRegister("wAkeP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $061f2abeddb05c5a$export$2e2bcd8739ae039; });
var $061f2abeddb05c5a$var$anchoredContent = function() {
    var anchorMenu = document.getElementById('js--anchored');
    if (!anchorMenu) return;
    var sections = document.querySelectorAll('.anchor');
    var isUserScrolling = false;
    if (!sections || !anchorMenu) return;
    var handleSmoothScroll = function(targetID) {
        var sectionID = document.getElementById(targetID);
        if (!sectionID) return;
        isUserScrolling = true;
        var offset = sectionID.getBoundingClientRect().top + window.scrollY;
        window.scrollTo(0, offset);
        setTimeout(function() {
            isUserScrolling = false;
        }, 1000);
    };
    var handleLinkToggle = function(activeTarget) {
        anchorMenu.querySelectorAll('a').forEach(function(link) {
            link.classList.toggle('js--active', link.getAttribute('data-target') === activeTarget);
        });
    };
    var handleAnchorEvent = function() {
        anchorMenu.addEventListener('click', function(e) {
            e.preventDefault();
            if (e.target.tagName !== 'A') return;
            var newTarget = e.target.getAttribute('data-target');
            handleLinkToggle(newTarget);
            handleSmoothScroll(newTarget);
        });
    };
    var observer = new IntersectionObserver(function(entries) {
        if (isUserScrolling) return;
        var firstVisible = entries.find(function(entry) {
            return entry.isIntersecting;
        });
        if (!firstVisible) return;
        var activeId = firstVisible.target.id;
        handleLinkToggle(activeId);
    }, {
        rootMargin: '-50% 0px -50% 0px',
        threshold: 0
    });
    sections.forEach(function(section) {
        return observer.observe(section);
    });
    handleAnchorEvent();
};
var $061f2abeddb05c5a$export$2e2bcd8739ae039 = $061f2abeddb05c5a$var$anchoredContent;

});

})();
//# sourceMappingURL=anchor.525a5184.js.map
